/* tslint:disable */

declare var Object: any;
export interface ExternalInterfaceInterface {
  "id"?: number;
}

export class ExternalInterface implements ExternalInterfaceInterface {
  "id": number;
  constructor(data?: ExternalInterfaceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ExternalInterface`.
   */
  public static getModelName() {
    return "ExternalInterface";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ExternalInterface for dynamic purposes.
  **/
  public static factory(data: ExternalInterfaceInterface): ExternalInterface{
    return new ExternalInterface(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ExternalInterface',
      plural: 'ExternalInterfaces',
      path: 'ExternalInterfaces',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
